module.exports = __webpack_public_path__ + "static/ageb-48947b143c5bbfd76a168fb59bfea691.png";